<div class="display-bulletin-container">
    <div class="db-wrapper" *ngFor="let b of displayList | keyvalue">
        <bulletin [bulletinObject]="b.value"></bulletin>
    </div>
</div>